export default function firstCharToUpperCase(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
